<<template>
  <div>
    <privs-list ref="privInfo" :data="privData" style="margin-bottom: 15px;">
      <!-- <el-button type="primary" size="mini" @click="submitPrivInfo">
        更新
      </el-button> -->
    </privs-list>
    <!-- <el-button icon="el-icon-edit" style="margin-left: auto;"> edit </el-button> -->
    <Privs-Form :privData='privData' ref="privsForm" @submit="submitForm" />
  </div>
</template>

  <script>
  import axios from 'axios';
  import PrivsForm from './privsForm.vue';
  import PrivsList from '../configComp/pageInfo.vue';
  export default {
    data() {
      return {
        privData: {}
      }
    },
    components: { PrivsForm, PrivsList },
    // props: ['privData'],
    methods: {
      // #region 提交更新
      async submitPrivInfo(e) {
        const saveData = this.$refs.privInfo.getEditData();
        const { id } = this.$route.query
        const obj = {
          id
        };
        saveData.map(i => {
          const { attrs, val } = i;
          obj[attrs] = val;
        })
        // return
        const { data } = await axios.post('/pmdm/admin/priv/update?id=' + id, obj)
        if (data.code == 200) {
          this.$message.success(data.message);
        } else {
          this.$message.error(data.message);
        }
      },
      async submitForm(e) {
        // console.log(e);
        // let url = !this.privDataList ? "pmdm/admin/priv/save" : 'pmdm/admin/priv/update?id=';
        const { data } = await axios.post('pmdm/admin/priv/update?id=' + e.id, e)
        if (data.code == 200) {
          this.$message.success(data.message);
          this.$emit('setRefresh', data.object);
          this.privData = { ...e }
        } else {
          this.$message.error(data.message);
        }
      },
      // #endregion

    },
    created() {
      this.privData = this.$route.query;
    },
  }


</script>

  <style scoped></style>